<template>
  <div class="station-footer">

  </div>
</template>

<script>
export default {
  name: "station-footer"
}
</script>

<style slot-scope lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-station/component/station-footer/index.vue